import { colorGray, colorPrimary } from '@atlas-frontend/design-tokens';
import { Card } from 'antd';
import styled from 'styled-components';

export const GraphCard = styled(Card)`
  min-width: 15em;
  max-width: 25em;

  &.selected {
    border-color: ${colorPrimary} !important;
    box-shadow: 0 0 9px -3px ${colorPrimary} !important;
  }

  .ant-card-head {
    margin-bottom: 0;
  }

  .ant-card-body {
    background: ${colorGray[1]};
  }
`;
